import { combineReducers } from 'redux'
import { loginReducer } from '../views/Login/behaviors.js'

const rootReducer = combineReducers({
  user: loginReducer
})

export default rootReducer;
